import { PkceEnvironmentConfig } from '../types';
import { scopes } from './common';

/**
 * PKCE configuration for LOCAL development environment
 * Applies to: localhost
 * Note: PKCE is typically disabled for localhost, but can be enabled via VITE_EXTERNAL_API_HOST
 */
export const localConfig: PkceEnvironmentConfig = Object.freeze({
  clientId: (() => {
    switch (process.env.VITE_EXTERNAL_API_TARGET_CLIENT) {
      case 'DEV':
        return process.env.VITE_CLIENT_ID_DEV || '';
      case 'TST':
        return process.env.VITE_CLIENT_ID_TST || '';
      default:
        return process.env.VITE_CLIENT_ID_PROD || '';
    }
  })(),
  authorizationUrl:
    process.env.VITE_EXTERNAL_API_HOST +
    `/api/oauth2/${process.env.VITE_EXTERNAL_API_TARGET_CLIENT || 'DEV'}/default/v1/authorize`,
  tokenUrl: `/api/oauth2/${process.env.VITE_EXTERNAL_API_TARGET_CLIENT || 'DEV'}/default/v1/token`,
  providerConfiguration:
    process.env.VITE_EXTERNAL_API_AUTH === 'idp'
      ? {
          idp: (() => {
            switch (process.env.VITE_EXTERNAL_API_TARGET_CLIENT) {
              case 'DEV':
              case 'TST':
                return process.env.VITE_IDP_PREPROD || '';
              default:
                return process.env.VITE_IDP_PROD || '';
            }
          })(),
          type: 'okta' as const,
        }
      : undefined,
  scope: scopes.join(' '),
  apiBaseUrl: '',
});
